// extracted by mini-css-extract-plugin
export var footer = "_pe-0";
export var inherit = "_pe-1";
export var input = "_pe-2";
export var modalContent = "_pe-3";
export var quillEditor = "_pe-4";
export var subtitle = "_pe-5";